export default {
  personalWorkspace: '个人空间',
  switchToCompany: '切换回公司',
  switchToPersonal: '切换回个人',
  switchCompany: '切换企业',
  profile: '个人信息',
  settings: '系统设置',
  logout: '退出登录',
  logoutConfirmTitle: '提示',
  logoutConfirmMessage: '确定要退出登录吗？',
  logoutConfirmOk: '确定',
  logoutConfirmCancel: '取消',
  logoutSuccess: '已退出登录',
  language: '语言',
  quickMenu: {
    settings: '设置',
    upload: '上传',
    retouch: '修图',
    qc: '品控',
    audit: '审核',
    share: '分享',
    pack: '打包'
  }
}
